/**
 * Created by petr on 26.01.15.
 */

$(document).ready(function () {
    var $filterModal = $('#filter-modal');
    var topDefault = false;

    $('#filter_advancedSearch').on('click keypress', function (e) {

        $filterModal.toggleClass("opened");

    });

    var $filterServices = $("#filter_services");
    var select2opts = {
        width: '100%',
        placeholder: "Нажмите для выбора",
        allowClear: true,
        minimumResultsForSearch: Infinity
    };
    $filterServices.select2(select2opts);

    $filterModal.find(".ui-dialog-titlebar-close").click(function () {
        $filterModal.removeClass("opened");
    });

    $(document).on('keydown', function ( e ) {
        if ( e.keyCode === 27 ) {
            $filterModal.removeClass("opened");
        }
    });

    $('#filter_sort').on('change', function () {
        $(this).closest('form').submit();
    });
});